$ = jQuery;

$( document ).foundation();

if( $( document ).find( '.__remove_side_text' )['length'] > 0 ) {
  $( '.__before_text, .__after_text' ).remove();
}